import React from 'react';
import ApplicationForm from '../components/ApplicationForm';
import './Application.css';

export default function Application() {
  return (
    <div className="application-page">
      <div className="application-container">
        <div className="application-header">
          <h1>Join Our Team</h1>
          <p>Ready to create amazing horror experiences? Fill out the application form below and let's build something incredible together.</p>
        </div>
        <ApplicationForm />
      </div>
    </div>
  );
}
